class ParallaxEffect {

  constructor() {
    this.debug = window.location.search == "?debug" ? true : false;
  }

  init() {

    let _self = this;

    let parallaxes = $('.has-parallax');
    if(_self.debug) console.log('ParallaxEffect parallaxes?', parallaxes);
    if(parallaxes.length) {


      parallaxes.each(function(i,parallax){
        if(_self.debug) console.log('ParallaxEffect parallax', parallax);
        if(_self.debug) console.log('ParallaxEffect parallax-target', $(parallax).find('.has-parallax-target').get(0));

        var theParallaxAnimation;
        let parallaxAnimation = $(parallax).find('.a-animation');
        if(parallaxAnimation.length) {
          theParallaxAnimation = eval('anim'+parallaxAnimation.attr('id'));
          if(_self.debug) console.log('ParallaxEffect animation?', theParallaxAnimation);
        }
        let parallaxTimeline = gsap.timeline({
          ease: "none",
          scrollTrigger: {
            id: 'parallaxEffect-'+i,
            trigger: parallax,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
            markers: _self.debug,
            onEnter: function(progress, direction, isActive){
              if(theParallaxAnimation) {
                theParallaxAnimation.setDirection(1);
                theParallaxAnimation.goToAndStop(0);
                setTimeout(function(){
                  theParallaxAnimation.play();
                },500);
              }
            },
            onEnterBack: function(progress, direction, isActive){
            if(_self.debug) console.log('ParallaxEffect onEnterBack?', theParallaxAnimation);
              if(theParallaxAnimation) {
                theParallaxAnimation.setDirection(-1);
                // theParallaxAnimation.goToAndStop(0);
                setTimeout(function(){
                  theParallaxAnimation.play();
                },500);
              }
            }
          },
        });

        ScrollTrigger.matchMedia({

          "(min-width: 768px)": function() {
            parallaxTimeline.fromTo($(parallax).find('.has-parallax-target').get(0),
              {
                yPercent: -20,
                scale: 1.1
              },
              {
                yPercent: 5,
                scale: 1
              }
            );
          },
          "(max-width: 767px)": function() {
            parallaxTimeline.fromTo($(parallax).find('.has-parallax-target').get(0),
              {
                yPercent: -20,
                scale: 1.3
              },
              {
                yPercent: 20,
                scale: 1
              }
            );
          }

        });

      });

    }
  }
}

export { ParallaxEffect };
